import axios from 'axios';
import { getToken } from 'utils';
export const BASE_URL=process.env.REACT_APP_API_URL;

const  instance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, // 30 seconds timeout
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    //"Access-Control-Allow-Origin": "*",
  }
});

// @ts-ignore
instance.interceptors.request.use((config: { headers: { [x: string]: string; }; url?: string; }) => {
  // Do something before request is sent
  const token = getToken();
  if(token && config.headers){
    config.headers["x-access-token"] = token;
  }
  return config;
}, function (error: any) {
  // Do something with request error
  return Promise.reject(error);
});

// Add response interceptor for debugging
instance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default instance;



